export default "__VITE_ASSET__CwrxkWu9__"